import { createSlice } from '@reduxjs/toolkit';
import { MenuState } from '../../types/menu';

const initialState: MenuState = {
  categories: [],
  items: [],
  addons: [],
  itemAddons: [],
  selectedOutletId: null,
  selectedCategoryId: null,
  isLoading: false,
  error: null,
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {},
});

export default menuSlice.reducer;
